import { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';

import { loadClientPaymentData } from 'actions/appointments';
import { DefaultPaymentMethod } from 'organisms/DefaultPaymentMethod';

export default function PaymentSelect({ uuid }) {
  const dispatch = useDispatch();
  const [isLoading, setIsLoading] = useState(false);
  const [paymentData, setPaymentData] = useState(null);

  useEffect(() => {
    setPaymentData(null);
    dispatch(loadClientPaymentData({ uuid })).then(({ success, data }) => {
      if (success) {
        const { payment } = data.data;
        setPaymentData(payment);
      }
    });
  }, [uuid]);

  if (!paymentData && !isLoading) return null;

  return (
    <div className="payment-select-panel flex-column mb-12 p-24 border-light-purple radius-24">
      <h4 className="mb-12">Payment</h4>
      {isLoading ? (
        'Loading...'
      ) : (
        <DefaultPaymentMethod
          cards={paymentData?.methods?.cards}
          savedCardLabel
        />
      )}
    </div>
  );
}
